(() => {
  'use strict';
  const validPrice = price => Number.isSafeInteger(price) && price >= 0;
  function separateMugsPrice(catalog, gift = false, config, quantity = 1) {
    if (typeof gift !== 'boolean' || !Number.isInteger(quantity) || quantity < 1 || quantity > 10) return null;
    const colors = catalog?.fondue?.colors, field = gift ? 'giftPrice' : 'price', available = gift ? 'giftAvailable' : 'available';
    const keys = ['brown', 'white', 'red'], entries = keys.map(color => colors?.[color]);
    if (entries.some(entry => !entry || entry[available] !== true || !validPrice(entry[field]))) return null;
    let total = entries.reduce((sum, entry) => sum + entry[field] * quantity, 0);
    if (config?.active === true) {
      if (!Number.isInteger(config.minQuantity) || config.minQuantity < 1 || !Number.isInteger(config.percent) || config.percent <= 0 || config.percent >= 100) return null;
      const eligible = keys.map(color => eligibleSelection({ key: 'fondue', color, gift }, catalog, config));
      if (eligible.filter(Boolean).length * quantity >= config.minQuantity) {
        for (let i = 0; i < entries.length; i++) if (eligible[i]) {
          const discount = entries[i][field] * config.percent / 100;
          if (!Number.isSafeInteger(discount)) return null;
          total -= discount * quantity;
        }
      }
    }
    return Number.isSafeInteger(total) ? total : null;
  }
  function trioSaving(catalog, gift = false, config) {
    const field = gift ? 'giftPrice' : 'price', trio = catalog?.fondue?.colors?.trio;
    if (!trio || trio[gift ? 'giftAvailable' : 'available'] !== true || !validPrice(trio[field])) return null;
    const separate = separateMugsPrice(catalog, gift, config);
    if (separate === null) return null;
    const saving = separate - trio[field];
    return Number.isSafeInteger(saving) && saving > 0 ? saving : null;
  }
  function eligibleSelection(input, catalog, config) {
    if (config?.active !== true || !config.eligible?.[input?.key]?.includes(input.color) || typeof input.gift !== 'boolean') return false;
    const variant = catalog?.[input.key]?.colors?.[input.color];
    const id = input.gift ? variant?.giftVariantId : variant?.variantId;
    return /^[1-9]\d*$/.test(String(id || '')) && (input.gift ? variant?.giftAvailable : variant?.available) === true;
  }
  function pricePreview(input, catalog, config) {
    if (!input || !Number.isInteger(input.quantity) || input.quantity < 1 || input.quantity > 10 || typeof input.gift !== 'boolean') return null;
    const variant = catalog?.[input.key]?.colors?.[input.color], field = input.gift ? 'giftPrice' : 'price';
    if (!variant || !validPrice(variant[field]) || (input.gift ? variant.giftAvailable : variant.available) !== true) return null;
    const finalCents = variant[field] * input.quantity;
    if (!Number.isSafeInteger(finalCents)) return null;
    if (input.key === 'fondue' && input.color === 'trio') {
      const originalCents = separateMugsPrice(catalog, input.gift, config, input.quantity);
      return originalCents === null || originalCents <= finalCents ? null : { kind: 'trio', originalCents, finalCents, quantity: input.quantity, comparedUnits: 3 * input.quantity };
    }
    if (!eligibleSelection(input, catalog, config) || !Number.isInteger(config.minQuantity) || input.quantity < config.minQuantity || !Number.isInteger(config.percent) || config.percent <= 0 || config.percent >= 100) return null;
    // Only show an exact preview; otherwise Shopify decides any cent rounding in the cart.
    const unitDiscount = variant[field] * config.percent / 100;
    if (!Number.isSafeInteger(unitDiscount)) return null;
    return { kind: 'quantity', originalCents: finalCents, finalCents: (variant[field] - unitDiscount) * input.quantity, quantity: input.quantity, percent: config.percent };
  }
  if (typeof module === 'object' && module.exports) module.exports = { trioSaving, separateMugsPrice, eligibleSelection, pricePreview };
  if (typeof document === 'undefined') return;
  function update(form) {
    if (!form) return;
    const config = window.SNIEZKOWO_PROMOTION || {}, catalog = window.SNIEZKOWO_PRODUCTS || {};
    const promotion = document.querySelector('[data-quantity-promotion]'), savingLabel = form.querySelector('[data-trio-saving]');
      const key = form.dataset.productKey, gift = form.querySelector('[data-gift]')?.checked || false;
      const kind = form.querySelector('input[name="kind"]:checked')?.value;
      const color = key === 'train' ? 'black' : kind === 'trio' ? 'trio' : form.querySelector('input[name="color"]:checked')?.value;
      if (promotion) promotion.hidden = !eligibleSelection({ key, color, gift }, catalog, config.quantity);
      const currency = window.SNIEZKOWO_CURRENCY;
      if (!/^[A-Z]{3}$/.test(currency || '')) { if (savingLabel) savingLabel.hidden = true; return; }
      try {
        const money = cents => new Intl.NumberFormat('pl-PL', { style: 'currency', currency }).format(cents / 100);
        function comparison(element, original, final) {
          const old = document.createElement('s'), current = document.createElement('span');
          old.textContent = money(original); current.textContent = money(final);
          element.classList.add('sniezkowo-price-comparison'); element.replaceChildren(old, document.createTextNode(' '), current);
        }
        if (savingLabel) {
          const saving = trioSaving(catalog, gift, config.quantity);
          savingLabel.hidden = saving === null || !config.trioSavingLabel;
          if (!savingLabel.hidden) {
            const final = catalog.fondue.colors.trio[gift ? 'giftPrice' : 'price'];
            comparison(savingLabel.querySelector('[data-trio-comparison-prices]'), final + saving, final);
            savingLabel.querySelector('[data-trio-saving-copy]').textContent = config.trioSavingLabel.replace('{amount}', money(saving));
          }
        }
        const raw = form.querySelector('[data-quantity]')?.value || '', quantity = /^\d+$/.test(raw) ? Number(raw) : NaN;
        const preview = pricePreview({ key, color, gift, quantity }, catalog, config.quantity), note = form.querySelector('[data-promotion-price-label]');
        if (note) note.hidden = !preview;
        if (!preview) return;
        const total = form.querySelector('[data-total]');
        if (total) comparison(total, preview.originalCents, preview.finalCents);
        if (note) note.textContent = preview.kind === 'trio'
          ? config.trioComparisonLabel.replace('{count}', String(preview.comparedUnits))
          : config.quantityPreviewLabel.replace('{quantity}', String(preview.quantity)).replace('{percent}', String(preview.percent));
        const sticky = document.querySelector('[data-sticky-summary]');
        if (sticky) sticky.textContent = sticky.textContent.split(' · ')[0] + ' · ' + money(preview.finalCents);
      } catch { if (savingLabel) savingLabel.hidden = true; }
  }
  window.SniezkowoPromotion = Object.freeze({ update });
  const mount = () => update(document.querySelector('[data-buy-form]'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true }); else mount();
})();
